import { Injectable } from '@angular/core';

export enum MbSecurityContext {
  UUID = 'MB_SECURITY_CONTEXT_INPUT_UUID',
  SLUG = 'MB_SECURITY_CONTEXT_INPUT_SLUG',
  RESOURCE_TYPE = 'MB_SECURITY_CONTEXT_INPUT_RESOURCE_TYPE',
  DIGITS = 'MB_SECURITY_CONTEXT_INPUT_DIGITS',
  LANG = 'MB_SECURITY_CONTEXT_INPUT_LANG',
  ELEMENT_ID = 'MB_SECURITY_CONTEXT_INPUT_ELEMENT_ID',
  CITY = 'MB_SECURITY_CONTEXT_INPUT_CITY',
}

@Injectable({ providedIn: 'root' })
export class InputSanitizer {
  public static sanitize(context: MbSecurityContext, value: string): string | null {
    if (!value) {
      return null;
    }
    switch (context) {
      case MbSecurityContext.UUID:
        return value.replace(/[^a-f0-9\-]+/gi, '').toLowerCase();
      case MbSecurityContext.SLUG:
        return value.replace(/[^a-z0-9_\-]+/gi, '').toLowerCase();
      case MbSecurityContext.RESOURCE_TYPE:
        return value.replace(/[^a-z0-9_\-]+/gi, '');
      case MbSecurityContext.DIGITS:
        return value.replace(/[^0-9]+/gi, '');
      case MbSecurityContext.LANG:
        return value.replace(/[^a-z0-9\-]+/gi, '');
      case MbSecurityContext.ELEMENT_ID:
        return value.replace(/[^\w\-\:\.]+/gi, '');
      case MbSecurityContext.CITY:
        return value.replace(/[^a-z0-9,\. \-()]+/gi, '');
    }
    return null;
  }

  // uuids are guids containing lowercased hex digits and optional hyphens
  // length is not validated, but invalid characters are removed and the string is lowercased
  public uuid(value: string) {
    return InputSanitizer.sanitize(MbSecurityContext.UUID, value);
  }

  // this can be a uuid or a human-readable slug like 'geneva2018'
  // alphanumerics, underscores and hyphens are allowed
  // characters are lowercased
  // invalid characters are removed
  public slug(value: string) {
    return InputSanitizer.sanitize(MbSecurityContext.SLUG, value);
  }

  // resourceTypes are names of data model entities e.g. 'article'
  // alphanumerics, underscores and hyphens are allowed
  // invalid characters are removed
  public resourceType(value: string) {
    return InputSanitizer.sanitize(MbSecurityContext.RESOURCE_TYPE, value);
  }

  // a string of digits
  // invalid characters are removed
  public digits(value: string) {
    return InputSanitizer.sanitize(MbSecurityContext.DIGITS, value);
  }

  public lang(value: string) {
    return InputSanitizer.sanitize(MbSecurityContext.LANG, value);
  }

  public elementId(value: string): string {
    return InputSanitizer.sanitize(MbSecurityContext.ELEMENT_ID, value) as string;
  }

  public float(value: string | number): number {
    if (typeof value !== 'number') {
      return Number(value);
    }
    return value;
  }

  public city(value: string) {
    return InputSanitizer.sanitize(MbSecurityContext.CITY, value);
  }
}
